import { useAuthorize } from '../../hooks/use-authorize';
import { GridColumnConfig } from '../../models/gridCoumnConfig';
import { UserPermissionName } from '../../models/user-permission-name';

export const servicesEditableColumns: GridColumnConfig[] = [
  {
    title: 'Sort Order',
    field: 'sortOrder',
    filter: 'numeric',
    width: '110',
  },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  // {
  //   title: 'Service Code',
  //   field: 'serviceCode',
  //   filter: 'text',
  //   searchable: true,
  //   width: '220',
  // },
  {
    title: 'Predecessor',
    field: 'predecessorNames',
    filter: 'text',
    width: '200',
  },
  {
    title: 'Billing Type',
    field: 'billingType',
    filter: 'text',
    width: '150',
  },
  {
    title: 'Service Group',
    field: 'serviceGroupName',
    filter: 'text',
    width: '150',
  },
  // {
  //   title: 'Forecast Days',
  //   field: 'forecastDays',
  //   filter: 'text',
  //   editable: true,
  //   editor: 'numeric',
  // },
  // {
  //   title: 'Invoice Amount ($)',
  //   field: 'price',
  //   filter: 'text',
  //   fieldType: 'currency',
  //   editable: true,
  //   editor: 'numeric',
  //   isDecimal: true,
  //   isDisable: true,
  // },
  // {
  //   title: 'Accrual Amount ($)',
  //   field: 'accrualAmount',
  //   filter: 'text',
  //   fieldType: 'currency',
  //   editable: true,
  //   editor: 'numeric',
  //   isDecimal: true,
  // },
  // {
  //   title: 'options',
  //   field: 'option',
  //   filter: 'text',
  // },
];
